/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AnalyticTable from 'components/kea/tables/AnalyticTable';
import CardContainer from 'components/kea/CardContainer';
import { getPopularByPurchase } from 'actions';
import { linkToProductDetail } from '../../../../../../util/appUtils';
import { useLocalizedMessage } from '../../../../../../util/useLocalizedMessage';
import cardStyles from '../../StoreAnalyticsCards.module.scss';

const PopularProductsByPurchase = () => {
  const dispatch = useDispatch();
  const localizeMessage = useLocalizedMessage();
  const { analytics: { products, timeframe }, app: { currentShop } } = useSelector((str) => str);
  const { popularByPurchase: { isFetching, data, error } } = products;

  useEffect(() => {
    dispatch(getPopularByPurchase(currentShop, timeframe));
  }, [timeframe]);

  const headCells = [
    {
      id: 'name',
      numeric: false,
      label: localizeMessage('analytics.table.productName'),
      sortKey: 'nameText',
    },
    { id: 'count', numeric: true, label: localizeMessage('analytics.table.purchases') },
  ];

  const prepareRows = (rows) => rows.map((e) => ({
    ...e,
    nameText: e.name,
    name: linkToProductDetail(currentShop, e.name, e.id),
  }));

  return (
    <CardContainer
      headerId="search.analytics.popularItemsByPurchase.header"
      styleName={`noMargin ${cardStyles.card} ${cardStyles.purchases}`}
      tableSurface
      isFetching={isFetching}
      error={error}
    >
      <AnalyticTable
        rows={prepareRows(data)}
        headCells={headCells}
        orderById="count"
        emptyMessageId="analytics.empty.popularPurchases"
      />
    </CardContainer>

  );
};

export default PopularProductsByPurchase;
